import { PieForExport } from 'components/PieTab/PieForExport';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { ExportModal } from 'components/UI/ExportModal';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, IconButton } from '@mui/material';
import {
  setBackdropLoadingAction,
  setExportingStatsAction,
} from 'store/actions/mainPage';

export const ExportPie: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { statisticsData, exportingStats: exporting } = useAppSelector(
    (state) => state.mainPage
  );
  const dispatch = useAppDispatch();

  if (!statisticsData) {
    return null;
  }

  const toggleOpen = () => {
    setOpen(!open);
  };

  const onExport = (ext: string) => {
    dispatch(setBackdropLoadingAction(true));
    setTimeout(() => {
      dispatch(setExportingStatsAction(true, ext));
    }, 100);
  };

  return statisticsData ? (
    <Box
      sx={{
        position: 'relative',
        mr: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        p: 1,
      }}
    >
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.primary.main,
          borderRadius: '4px',
        }}
      >
        <IconButton sx={{ color: 'white' }} onClick={toggleOpen}>
          <DownloadIcon fontSize="large" />
        </IconButton>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          right: '60px',
          bottom: '7px',
          backgroundColor: 'white',
        }}
      >
        <ExportModal
          exportCb={onExport}
          handleClose={toggleOpen}
          open={open}
          ext={['pdf', 'png']}
        />
      </Box>
      {exporting && <PieForExport setOpen={setOpen} />}
    </Box>
  ) : (
    <></>
  );
};
